import { PalletteProps } from '../types/theme/pallette';
import { lighten } from 'polished';

import { createGlobalStyle } from 'styled-components';

export const ToastifyStyles = createGlobalStyle`

  @media only screen and (max-width: 480px) {
    .Toastify__toast {
        margin-bottom: 1rem;
    }
  }

  .Toastify__toast-container {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 320px !important;
  }

  .Toastify__toast {
    border-radius: 12px !important;
    padding: 12px !important;
    font-family: 'Inter', sans-serif !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  .Toastify__toast--success {
    background: ${({ theme }: PalletteProps) =>
      lighten(0.4, theme.toastifySuccess)} !important;
    color:${({ theme }: PalletteProps) => theme.toastifySuccess} !important;
    border: 1px solid ${({ theme }: PalletteProps) =>
      lighten(0.3, theme.toastifySuccess)} !important;
  }

  .Toastify__toast--error {
    background: ${({ theme }: PalletteProps) =>
      lighten(0.4, theme.toastifyError)} !important;
    color:${({ theme }: PalletteProps) => theme.toastifyError} !important;
    border: 1px solid ${({ theme }: PalletteProps) =>
      lighten(0.3, theme.toastifyError)} !important;
  }

  .Toastify__toast--warning {
    background: ${({ theme }: PalletteProps) =>
      lighten(0.4, theme.toastifyWarning)} !important;
    color:${({ theme }: PalletteProps) => theme.toastifyWarning} !important;
    border: 1px solid ${({ theme }: PalletteProps) =>
      lighten(0.3, theme.toastifyWarning)} !important;
  }

  .Toastify__toast--info {
    background: ${({ theme }: PalletteProps) =>
      lighten(0.4, theme.toastifyInfo)} !important;
    color:${({ theme }: PalletteProps) => theme.toastifyInfo} !important;
    border: 1px solid ${({ theme }: PalletteProps) =>
      lighten(0.3, theme.toastifyInfo)} !important;
  }

  .Toastify__toast-icon {
    margin-right: 8px !important;
  }

  .Toastify__close-button {
    color: #5f5f5f !important;
    opacity: 0.7 !important;
  }

  .Toastify__close-button:hover {
    opacity: 1 !important;
  }

  .Toastify__toast--enter {
    transform: translateX(100%);
  }

  .Toastify__toast--enter-active {
    transform: translateX(0);
    transition: transform 300ms ease-in;
  }

  .Toastify__toast--exit {
    transform: translateX(0);
  }

  .Toastify__toast--exit-active {
    transform: translateX(100%);
    transition: transform 300ms ease-in;
  }
`;
